<template>
    <div>
        <v-card elevation="0">
            <v-card color="#98B38F" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-lock-check-outline</v-icon>
                    &nbsp;Permissions / Users
                </v-card-title>
            </v-card>
            <v-card-text>
                <Manager />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/Permissions/Manager.vue"
export default {
    components: {
        Manager
    }
}
</script>